import { NgModule } from '@angular/core';

import { InformativePebbleIconComponent } from './informative-pebble-icon.component';
import { VpgrooveModule } from '@engineering/vpgroove-angular';
import { GenesisPipesModule } from '@genesis-frontend/genesis-utilities';


@NgModule({
    imports: [
        VpgrooveModule,
        GenesisPipesModule
    ],
    declarations: [
        InformativePebbleIconComponent
    ],
    exports: [
        InformativePebbleIconComponent
    ]
})
export class InformativePebbleIconModule { }
